<template>
  <div
    class="answer-item-block"
    style=""
    :style="index % 2 == 1 ? 'background: #17a2b842;' : 'background: #fdd7b7'"
  >
    <!-- 疑点标题 -->
    <div class="title-block">
      <b>{{ index }}、{{ item.questionName }}</b>
      <el-button
        v-if="suspectsList && suspectsList.length && checkPermission('疑点:排除疑点', permList)"
        type="danger"
        size="mini"
        :disabled="isCaseArchive"
        @click="onClickExcludeBtn"
      >
        排除
      </el-button>
    </div>
    <!-- 新加的记录 -->
    <div
      v-for="(ruleItem, ruleIndex) in item.optionsInfos"
      :key="ruleIndex"
      style="width: 100%"
    >
      <div
        v-for="(answerItem, answerIndex) in ruleItem.suspects.filter(
          (item, index) =>
            showList[ruleIndex].isShow == true ||
            (showList[ruleIndex].isShow == false && index == 0)
        )"
        :key="answerIndex"
        class="answer-item"
      >
        <div class="answer-item-flex">
          <!-- 如果该疑点已被排除，则修改样式，增加删除线样式 -->
          <div
            :class="
              answerItem.excluded ? 'line-through answer-item-flex' : 'answer-item-flex'
            "
          >
            <!-- 疑点标题 -->
            <el-tooltip
              class="answer-item-title"
              effect="dark"
              placement="top-start"
              transition="el-fade-in"
            >
              <div slot="content" style="max-width: 500px; line-height: 18px">
                {{ answerItem.suspectInfo }}
              </div>
              <span v-if="answerIndex == 0">{{ index }}.{{ ruleIndex + 1 }}、</span>
              <span v-else style="width: 30px; display: inline-block" />
              <span v-if="answerIndex == 0">疑点：{{ answerItem.suspectInfo }}</span>
            </el-tooltip>
            <div style="min-width: 300px; margin-right: 15px">
              备注：{{ answerItem.remark }}
            </div>
            <div style="width: 220px">疑点标注时间：{{ answerItem.createTime }}</div>
            <div>备注人：{{ answerItem.creator }}</div>
          </div>
          <!-- 排除疑点勾选框 -->
          <el-checkbox
            v-if="!answerItem.excluded && checkPermission('疑点:排除疑点', permList)"
            v-model="allSuspectsList[ruleIndex][answerIndex].excluded"
            :disabled="isCaseArchive"
            class="answer-item-checkbox"
            @change="(value) => onChangeAnswerCheckbox(value, answerItem.suspectCode)"
          />
        </div>

        <!-- 疑点展开 -->
        <el-button
          v-if="
            ruleItem.suspects.length > 1 &&
              showList[ruleIndex].isShow == false &&
              answerIndex == 0
          "
          icon="el-icon-arrow-down"
          size="small"
          circle
          class="sub-btn icon-btn"
          @click="show(ruleIndex, true)"
        />
        <!-- 疑点收起 -->
        <el-button
          v-if="
            ruleItem.suspects.length == answerIndex + 1 &&
              showList[ruleIndex].isShow == true
          "
          icon="el-icon-arrow-up"
          size="small"
          circle
          class="sub-btn icon-btn"
          @click="show(ruleIndex, false)"
        />
      </div>
    </div>
    <div
      v-if="item.communicates.length > 0 || checkPermission('沟通备注:添加', permList)"
      class="note-block"
    >
      <!-- 已添加的沟通备注信息 -->
      <template v-if="item.communicates.length > 0">
        <div
          v-for="(insuranceItem, insuranceIndex) in item.communicates"
          :key="insuranceIndex"
          class="flex note-msg-block"
          :style="insuranceIndex % 2 == 0 ? 'background: #ffc10761;' : ''"
        >
          <span class="fl">沟通备注：</span>
          <span class="fl mr10" style="width: 600px">{{
            insuranceItem.suspectRemark
          }}</span>
          <span class="fl mr10">备注人:</span>
          <span class="fl mr10" style="width: 80px">{{ insuranceItem.editor }}</span>
          <span class="fl mr10">沟通时间:</span>
          <span class="fl">{{ insuranceItem.editTime }}</span>
        </div>
      </template>
      <template v-if="checkPermission('沟通备注:添加', permList)">
        <div v-for="(communicate, cIndex) in newCommunicates" :key="cIndex" class="flex">
          <div class="search-con-item flex">
            <span class="fl">沟通备注：</span>
            <span>
              <el-input
                v-model="communicate.suspectRemark"
                style="width: 600px"
                placeholder="请填写沟通备注"
                @change="remarkChanged"
              />
            </span>
          </div>
          <!-- <div class="search-con-item sub-block" @click="reduceRemark(index)">-</div> -->
          <!-- 删除沟通备注输入框 -->
          <el-button
            type="danger"
            icon="el-icon-minus"
            circle
            size="mini"
            class="icon-btn"
            :disabled="isCaseArchive"
            @click="reduceRemark(cIndex)"
          />
        </div>
      </template>
      <div v-if="checkPermission('沟通备注:添加', permList)" class="flex">
        <div class="search-con-item flex">
          <span class="fl">沟通备注：</span>
          <span>
            <el-input
              v-model="suspectRemark"
              style="width: 600px"
              placeholder="请填写沟通备注"
              @change="remarkChanged"
            />
          </span>
        </div>
        <!-- <div class="search-con-item add-block" @click="addRemark">+</div> -->
        <!-- 增加沟通备注输入框 -->
        <el-button
          type="primary"
          icon="el-icon-plus"
          circle
          size="mini"
          class="icon-btn"
          :disabled="isCaseArchive"
          @click="addRemark"
        />
      </div>
    </div>

    <!-- 排除疑点的确认弹出窗 -->
    <el-dialog title="温馨提示" :visible.sync="excludeDialogVisible" width="20%" center>
      <span>请修改对应资料确认信息，确认排除此疑点？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHideExcludeDialog">取 消</el-button>
        <el-button type="primary" @click="onSubmitExcludeDialog">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AnswerItem',
  props: {
    item: {
      type: Object,
      default: () => { return {} }
    },
    index: {
      type: Number,
      default: 0
    },
    // 案件编号
    caseCode: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      showList: [],
      newCommunicates: [],
      suspectRemark: '',
      excludeDialogVisible: false, // 控制确认对话框显示/隐藏
      suspectsList: [], // 未被排除的疑点列表
      allSuspectsList: [], // 所有疑点的列表数据（方便复选框勾选状态的展示）
      suspectCodeArr: [], // 被选中的疑点编号
      remark: '' // 被选中的疑点信息（JSON格式）
    }
  },

  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo,
      permList: (state) => state.permission.permList,
    }),

    // 判断当前案件是否为“归档”流程
    isCaseArchive() {
      return this.caseInfo.flowCode >= 103500;
    },
  },

  watch: {
    item(newValue, oldValue) {
      this.init()
    }
  },

  created() {
    this.init()
  },

  methods: {
    init() {
      const suspectsList = [] // 未被排除的疑点列表
      const allSuspectsList = [] // 重新列举所有疑点列表
      this.showList = []
      this.newCommunicates = []
      this.suspectRemark = ''
      this.item.optionsInfos.forEach((i, index) => {
        var showObj = {
          index: index,
          isShow: false
        }
        this.showList.push(showObj)
        allSuspectsList.push(i && i.suspects)

        // 遍历所有疑点列表里，每小点的数据
        i &&
          i.suspects &&
          i.suspects.forEach((newItem, newIndex) => {
            // 如果改疑点已被排除，则不添加到数组（suspectsList）里
            if (!newItem.excluded) {
              suspectsList.push({
                createTime: newItem.createTime,
                creator: newItem.creator,
                excluded: newItem.excluded,
                remark: newItem.remark,
                suspectCode: newItem.suspectCode,
                suspectInfo: newItem.suspectInfo
              })
            }
          })
      })

      this.suspectsList = JSON.parse(JSON.stringify(suspectsList))
      this.allSuspectsList = JSON.parse(JSON.stringify(allSuspectsList))
    },

    /**
     * 展开/收起疑点列表
     */
    show(index, isShow) {
      this.showList.forEach((i) => {
        if (Number(i.index) === Number(index)) {
          i.isShow = isShow
        }
      })
    },

    /**
     * 增加沟通备注
     */
    addRemark() {
      if (this.suspectRemark === '') {
        this.$alert('请先填写沟通备注')
        return
      }
      var addItem = {
        suspectRemark: this.suspectRemark
      }
      this.newCommunicates.push(addItem)
      this.suspectRemark = ''
    },

    /**
     * 减少沟通备注
     */
    reduceRemark(currnetItem) {
      var currentSelect = []
      this.newCommunicates.forEach((item, index) => {
        if (Number(currnetItem) !== Number(index)) {
          currentSelect.push(item)
        }
      })
      this.newCommunicates = currentSelect

      this.remarkChanged()
    },

    /**
     * 沟通备注修改
     */
    remarkChanged() {
      var updateArray = []
      var vm = this
      if (vm.newCommunicates != null) {
        vm.newCommunicates.forEach((i) => {
          updateArray.push(i)
        })
      }
      if (this.suspectRemark !== '') {
        updateArray.push({ suspectRemark: this.suspectRemark })
      }
      vm.$emit('updateCommunicates', this.item.questionCode, updateArray)
    },

    /**
     * 点击排除按钮事件
     */
    onClickExcludeBtn() {
      const suspectsList = this.suspectsList
      const remark = {}
      const suspectCodeArr = [] // 疑点编号数组（被选中的）

      remark.questionName = this.item.questionName
      remark.optionsInfos = []

      // 遍历数组，获取要排除的疑点编号
      suspectsList &&
        suspectsList.forEach((item) => {
          if (item.excluded) {
            suspectCodeArr.push(item.suspectCode)
            remark.optionsInfos.push(item)
          }
        })

      // 简单的校验，判断是否又被选中的疑点编号
      if (suspectCodeArr && suspectCodeArr.length) {
        this.excludeDialogVisible = true
        this.suspectCodeArr = suspectCodeArr
        this.remark = JSON.stringify(remark)
      } else {
        this.$message.error('请选择您要排除的疑点！')
      }
    },

    /**
     * 隐藏疑点排除确认对话框
     */
    onHideExcludeDialog() {
      this.excludeDialogVisible = false
    },

    /**
     * 疑点排除确认对话框-确认按钮点击事件
     */
    onSubmitExcludeDialog() {
      const caseCode = this.caseCode // 案件编号
      const suspectCodeArr = this.suspectCodeArr // 疑点编号数组
      const remark = this.remark // 疑点信息（JSON格式）

      if (suspectCodeArr && suspectCodeArr.length) {
        // 调用疑点排除接口
        this.fetchRuleSuspectExclude(caseCode, suspectCodeArr, remark)
      }
      this.excludeDialogVisible = false
    },

    /**
     * 获取排除疑点复选框的改变状态
     * @param {boolean} value  复选框的状态
     * @param {string} suspectCode  疑点编号
     */
    onChangeAnswerCheckbox(value, suspectCode) {
      const suspectsList = this.suspectsList

      // 遍历未被排除的疑点列表，标记选中状态
      const newList =
        suspectsList &&
        suspectsList.map((item) => {
          if (Number(item.suspectCode) === Number(suspectCode)) {
            item.excluded = value
          }
          return item
        })

      this.suspectsList = JSON.parse(JSON.stringify(newList))
    },

    /**
     * 案件疑点-排除
     * @param {string} caseCode 案件编号
     * @param {string} suspectCode 疑点编号
     * @param {string} remark 疑点信息JSON格式
     */
    fetchRuleSuspectExclude(caseCode, suspectCode, remark) {
      const vm = this
      const params = {
        caseCode,
        suspectCode,
        remark
      }
      vm.axios
        .post(vm.homePath() + '/rule-suspect/exclude', params)
        .then((res) => {
          if (res.data.status === '000000') {
            // 排除成功后
            vm.$emit('updateRuleSuspectData') // 更新疑点列表信息
            vm.$emit('updateCaseOperationList') // 更新历史记录信息
          } else {
            vm.$alert(res.data.message || '服务器繁忙，请稍后重试', '提示')
          }
        })
        .catch((error) => console.log(error))
    }
  }
}
</script>

<style scoped lang="scss">
.answer-item-block {
  display: inline-block;
  width: 100%;
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 4px;
  box-sizing: border-box;

  /* 沟通备注 */
  .note-block {
    display: inline-block;
    padding: 8px 15px;
    border-radius: 6px;
    margin-top: 6px;
    background-color: #e8e8e8;

    /* 已添加的沟通备注内容 */
    .note-msg-block {
      width: 100%;
      line-height: 24px;
      padding: 2px 6px;
      margin-bottom: 10px;
      font-size: 14px;
      border-radius: 4px;
      align-items: flex-start;
    }

    /* 沟通备注-旧添加样式 */
    .add-block {
      width: 20px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #99a9bf;
      cursor: pointer;
      margin-top: 4px;
    }

    /* 沟通备注-旧删除样式 */
    .sub-block {
      width: 20px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: 1px solid #99a9bf;
      cursor: pointer;
    }
  }
}

.flex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.fl {
  float: left;
}

.mr10 {
  margin-right: 10px;
}

.title-block {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 15px;
  margin-bottom: 5px;
}

/* 删除线 */
.line-through span,
.line-through div {
  text-decoration: line-through;
  color: #999;
}

// 各疑点小结的排版
.answer-item {
  width: 100%;
  line-height: 30px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  justify-content: space-between;

  .answer-item-flex {
    display: flex;
    display: -webkit-flex;
    align-items: flex-start;
  }

  .answer-item-title {
    width: 350px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 14px;
    margin-right: 8px;
  }

  .answer-item-checkbox {
    margin: 0 0 0 10px;
  }
}
</style>
